import React from "react";
import { observer } from "mobx-react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import { ArrowBackIcon, CloseIcon } from "../../icons";
import { useRootStore } from "../../store/contexts/RootStoreContext";
import { UserModalContent } from "../../entities/user/components/modal/UserModalContent";
import { RoleModalContent } from "../../entities/role/components/modal/RoleModalContent";
import { PermissionModalContent } from "../../entities/permission/components/modal/PermissionModalContent";
import { TenantModalContent } from "../../entities/tenant/components/modal/TenantModalContent";
import { TenantProfileModalContent } from "../../entities/tenantProfile/components/modal/TenantProfileModalContent";
import { VatStatusModalContent } from "../../entities/vatStatus/components/modal/VatStatusModalContent";
import { GrossReceiptsStatusModalContent } from "../../entities/grossReceiptsStatus/components/modal/GrossReceiptsStatusModalContent";
import { TenantTypeModalContent } from "../../entities/tenantType/components/modal/TenantTypeModalContent";
import { TenantStatusModalContent } from "../../entities/tenantStatus/components/modal/TenantStatusModalContent";
import { CurrencyModalContent } from "../../entities/currency/components/modal/CurrencyModalContent";
import { TenantPlanModalContent } from "../../entities/tenantPlan/components/modal/TenantPlanModalContent";
import { CountryModalContent } from "../../entities/country/components/modal/CountryModalContent";
import { ProvinceStateModalContent } from "../../entities/provinceState/components/modal/ProvinceStateModalContent";
import { CreditTierModalContent } from "../../entities/creditTier/components/modal/CreditTierModalContent";
import { CreditAccountModalContent } from "../../entities/creditAccount/components/modal/CreditAccountModalContent";
import { CreditPurchaseModalContent } from "../../entities/creditPurchase/components/modal/CreditPurchaseModalContent";
import { CreditMovementModalContent } from "../../entities/creditMovement/components/modal/CreditMovementModalContent";
import { WorkerEventModalContent } from "../../entities/workerEvent/components/modal/WorkerEventModalContent";
import { SimulationSessionModalContent } from "../../entities/simulationSession/components/modal/SimulationSessionModalContent";
import { SnapshotOverrideModalContent } from "../../entities/snapshotOverride/components/modal/SnapshotOverrideModalContent";
import { BotRunModalContent } from "../../entities/botRun/components/modal/BotRunModalContent";
import { BotPhaseModalContent } from "../../entities/botPhase/components/modal/BotPhaseModalContent";
import { BotStepModalContent } from "../../entities/botStep/components/modal/BotStepModalContent";
import { BotErrorModalContent } from "../../entities/botError/components/modal/BotErrorModalContent";
import { SatelliteMachineModalContent } from "../../entities/satelliteMachine/components/modal/SatelliteMachineModalContent";
import { SatelliteTaskModalContent } from "../../entities/satelliteTask/components/modal/SatelliteTaskModalContent";
import { SatelliteHeartbeatModalContent } from "../../entities/satelliteHeartbeat/components/modal/SatelliteHeartbeatModalContent";
import { DashboardWidgetModalContent } from "../../entities/dashboardWidget/components/modal/DashboardWidgetModalContent";
import { TenantWidgetAccessModalContent } from "../../entities/tenantWidgetAccess/components/modal/TenantWidgetAccessModalContent";
import { UserWidgetConfigModalContent } from "../../entities/userWidgetConfig/components/modal/UserWidgetConfigModalContent";
import { DashboardLayoutTemplateModalContent } from "../../entities/dashboardLayoutTemplate/components/modal/DashboardLayoutTemplateModalContent";
import { ReportModalContent } from "../../entities/report/components/modal/ReportModalContent";
import { ReportTypeModalContent } from "../../entities/reportType/components/modal/ReportTypeModalContent";
import { UserNotificationModalContent } from "../../entities/userNotification/components/modal/UserNotificationModalContent";
import { UserNotificationPreferenceModalContent } from "../../entities/userNotificationPreference/components/modal/UserNotificationPreferenceModalContent";
import { AlertRuleModalContent } from "../../entities/alertRule/components/modal/AlertRuleModalContent";
import { AlertSubscriptionModalContent } from "../../entities/alertSubscription/components/modal/AlertSubscriptionModalContent";
import { EmailVerificationModalContent } from "../../entities/emailVerification/components/modal/EmailVerificationModalContent";
import { ShowcaseWorkflowStateModalContent } from "../../entities/showcaseWorkflowState/components/modal/ShowcaseWorkflowStateModalContent";
import { ShowcaseCategoryModalContent } from "../../entities/showcaseCategory/components/modal/ShowcaseCategoryModalContent";
import { ShowcaseLineModalContent } from "../../entities/showcaseLine/components/modal/ShowcaseLineModalContent";
import { DesignShowcaseModalContent } from "../../entities/designShowcase/components/modal/DesignShowcaseModalContent";
import { ThemeModalContent } from "../../entities/theme/components/modal/ThemeModalContent";
import { AuthorComposerModalContent } from "../../entities/authorComposer/components/modal/AuthorComposerModalContent";
import { CollectiveManagementSocietyModalContent } from "../../entities/collectiveManagementSociety/components/modal/CollectiveManagementSocietyModalContent";
import { AuthorCollectingSocietyModalContent } from "../../entities/authorCollectingSociety/components/modal/AuthorCollectingSocietyModalContent";
import { PublisherModalContent } from "../../entities/publisher/components/modal/PublisherModalContent";
import { AuthorPublisherModalContent } from "../../entities/authorPublisher/components/modal/AuthorPublisherModalContent";
import { WorkAuthorPublisherModalContent } from "../../entities/workAuthorPublisher/components/modal/WorkAuthorPublisherModalContent";
import { PublisherCollectingSocietyModalContent } from "../../entities/publisherCollectingSociety/components/modal/PublisherCollectingSocietyModalContent";
import { PublisherRepresentativeModalContent } from "../../entities/publisherRepresentative/components/modal/PublisherRepresentativeModalContent";
import { EditionTypeModalContent } from "../../entities/editionType/components/modal/EditionTypeModalContent";
import { MusicalWorkModalContent } from "../../entities/musicalWork/components/modal/MusicalWorkModalContent";
import { PhonogramModalContent } from "../../entities/phonogram/components/modal/PhonogramModalContent";
import { TerritoryModalContent } from "../../entities/territory/components/modal/TerritoryModalContent";
import { MusicalWorkLinkModalContent } from "../../entities/musicalWorkLink/components/modal/MusicalWorkLinkModalContent";
import { PlatformModalContent } from "../../entities/platform/components/modal/PlatformModalContent";
import { PlatformLinkTypeModalContent } from "../../entities/platformLinkType/components/modal/PlatformLinkTypeModalContent";
import { WorkAuthorModalContent } from "../../entities/workAuthor/components/modal/WorkAuthorModalContent";
import { EditionModalContent } from "../../entities/edition/components/modal/EditionModalContent";
import { SignedEditionModalContent } from "../../entities/signedEdition/components/modal/SignedEditionModalContent";
import { EditionContractPublisherModalContent } from "../../entities/editionContractPublisher/components/modal/EditionContractPublisherModalContent";
import { EditionDocumentationModalContent } from "../../entities/editionDocumentation/components/modal/EditionDocumentationModalContent";
import { SignedContractModalContent } from "../../entities/signedContract/components/modal/SignedContractModalContent";
import { EditionDocumentTypeModalContent } from "../../entities/editionDocumentType/components/modal/EditionDocumentTypeModalContent";
import { AssociatedDocumentEditionModalContent } from "../../entities/associatedDocumentEdition/components/modal/AssociatedDocumentEditionModalContent";
import { AssociatedDocumentSignedEditionModalContent } from "../../entities/associatedDocumentSignedEdition/components/modal/AssociatedDocumentSignedEditionModalContent";
import { SignedEditionBlockchainCertModalContent } from "../../entities/signedEditionBlockchainCert/components/modal/SignedEditionBlockchainCertModalContent";
import { UserAttachmentEditionModalContent } from "../../entities/userAttachmentEdition/components/modal/UserAttachmentEditionModalContent";
import { InterpreterModalContent } from "../../entities/interpreter/components/modal/InterpreterModalContent";
import { MusicalGenreModalContent } from "../../entities/musicalGenre/components/modal/MusicalGenreModalContent";
import { ContractObservationModalContent } from "../../entities/contractObservation/components/modal/ContractObservationModalContent";
import { PaymentReceiptTypeModalContent } from "../../entities/paymentReceiptType/components/modal/PaymentReceiptTypeModalContent";
import { PaymentReceiptUseModalContent } from "../../entities/paymentReceiptUse/components/modal/PaymentReceiptUseModalContent";
import { PaymentReceiptModalContent } from "../../entities/paymentReceipt/components/modal/PaymentReceiptModalContent";
import { TadManagerConfigModalContent } from "../../entities/tadManagerConfig/components/modal/TadManagerConfigModalContent";
import { DocumentGenerationParamsModalContent } from "../../entities/documentGenerationParams/components/modal/DocumentGenerationParamsModalContent";
import { EditionDocumentationWorkflowStateModalContent } from "../../entities/editionDocumentationWorkflowState/components/modal/EditionDocumentationWorkflowStateModalContent";
import { SignedEditionDndaWorkflowStateModalContent } from "../../entities/signedEditionDndaWorkflowState/components/modal/SignedEditionDndaWorkflowStateModalContent";
import { SignedEditionSadaicWorkflowStateModalContent } from "../../entities/signedEditionSadaicWorkflowState/components/modal/SignedEditionSadaicWorkflowStateModalContent";
import { LlmProviderModalContent } from "../../entities/llmProvider/components/modal/LlmProviderModalContent";
import { TenantLlmConfigModalContent } from "../../entities/tenantLlmConfig/components/modal/TenantLlmConfigModalContent";
import { TenantDocumentModalContent } from "../../entities/tenantDocument/components/modal/TenantDocumentModalContent";
import { AiSearchConversationModalContent } from "../../entities/aiSearchConversation/components/modal/AiSearchConversationModalContent";
import { AiSearchResponseModalContent } from "../../entities/aiSearchResponse/components/modal/AiSearchResponseModalContent";
import { AiSearchToolCallModalContent } from "../../entities/aiSearchToolCall/components/modal/AiSearchToolCallModalContent";
import { TenantTokenUsageModalContent } from "../../entities/tenantTokenUsage/components/modal/TenantTokenUsageModalContent";
import { TenantStorageUsageModalContent } from "../../entities/tenantStorageUsage/components/modal/TenantStorageUsageModalContent";
import { AiSearchAutoEvalModalContent } from "../../entities/aiSearchAutoEval/components/modal/AiSearchAutoEvalModalContent";
import { AiSearchPatternModalContent } from "../../entities/aiSearchPattern/components/modal/AiSearchPatternModalContent";
import { EvaluationQueryModalContent } from "../../entities/evaluationQuery/components/modal/EvaluationQueryModalContent";
import { QueryPatternModalContent } from "../../entities/queryPattern/components/modal/QueryPatternModalContent";
import { EsignatureConfigModalContent } from "../../entities/esignatureConfig/components/modal/EsignatureConfigModalContent";
import { EsignatureDocumentModalContent } from "../../entities/esignatureDocument/components/modal/EsignatureDocumentModalContent";
import { EsignatureRecipientModalContent } from "../../entities/esignatureRecipient/components/modal/EsignatureRecipientModalContent";
import { EsignatureWebhookEventModalContent } from "../../entities/esignatureWebhookEvent/components/modal/EsignatureWebhookEventModalContent";

const entityModalMaxWidth: Record<string, "sm" | "md" | "lg"> = {
  user: "lg",
  role: "sm",
  permission: "sm",
  tenant: "lg",
  tenantProfile: "lg",
  vatStatus: "sm",
  grossReceiptsStatus: "sm",
  tenantType: "sm",
  tenantStatus: "sm",
  currency: "sm",
  tenantPlan: "sm",
  country: "sm",
  provinceState: "sm",
  creditTier: "md",
  creditAccount: "lg",
  creditPurchase: "md",
  creditMovement: "md",
  workerEvent: "lg",
  simulationSession: "lg",
  snapshotOverride: "md",
  botRun: "lg",
  botPhase: "lg",
  botStep: "md",
  botError: "md",
  satelliteMachine: "lg",
  satelliteTask: "lg",
  satelliteHeartbeat: "lg",
  dashboardWidget: "lg",
  tenantWidgetAccess: "sm",
  userWidgetConfig: "md",
  dashboardLayoutTemplate: "md",
  report: "md",
  reportType: "sm",
  userNotification: "lg",
  userNotificationPreference: "sm",
  alertRule: "sm",
  alertSubscription: "sm",
  emailVerification: "sm",
  showcaseWorkflowState: "sm",
  showcaseCategory: "sm",
  showcaseLine: "sm",
  designShowcase: "lg",
  theme: "sm",
  authorComposer: "lg",
  collectiveManagementSociety: "sm",
  authorCollectingSociety: "sm",
  publisher: "lg",
  authorPublisher: "sm",
  workAuthorPublisher: "sm",
  publisherCollectingSociety: "sm",
  publisherRepresentative: "md",
  editionType: "sm",
  musicalWork: "lg",
  phonogram: "lg",
  territory: "sm",
  musicalWorkLink: "sm",
  platform: "sm",
  platformLinkType: "sm",
  workAuthor: "lg",
  edition: "lg",
  signedEdition: "lg",
  editionContractPublisher: "sm",
  editionDocumentation: "sm",
  signedContract: "sm",
  editionDocumentType: "sm",
  associatedDocumentEdition: "sm",
  associatedDocumentSignedEdition: "sm",
  signedEditionBlockchainCert: "sm",
  userAttachmentEdition: "sm",
  interpreter: "sm",
  musicalGenre: "sm",
  contractObservation: "md",
  paymentReceiptType: "sm",
  paymentReceiptUse: "sm",
  paymentReceipt: "lg",
  tadManagerConfig: "md",
  documentGenerationParams: "sm",
  editionDocumentationWorkflowState: "sm",
  signedEditionDndaWorkflowState: "sm",
  signedEditionSadaicWorkflowState: "sm",
  llmProvider: "md",
  tenantLlmConfig: "md",
  tenantDocument: "md",
  aiSearchConversation: "md",
  aiSearchResponse: "lg",
  aiSearchToolCall: "md",
  tenantTokenUsage: "lg",
  tenantStorageUsage: "md",
  aiSearchAutoEval: "lg",
  aiSearchPattern: "lg",
  evaluationQuery: "lg",
  queryPattern: "lg",
  esignatureConfig: "md",
  esignatureDocument: "lg",
  esignatureRecipient: "md",
  esignatureWebhookEvent: "sm",
};

export const ModalView: React.FC = observer(() => {
  const rootStore = useRootStore();
  const { modalViewOpen, modalViewStack } = rootStore;

  if (!modalViewOpen || modalViewStack.length === 0) {
    return null;
  }

  const currentView = modalViewStack[modalViewStack.length - 1];
  const canGoBack = modalViewStack.length > 1;
  const modalBp = entityModalMaxWidth[currentView.entityType] ?? "lg";
  const isWideModal = modalBp === "lg" || modalBp === "xl";

  const handleClose = () => {
    rootStore.closeModalView();
  };

  const handleBack = () => {
    rootStore.popModalView();
  };

  const renderContent = () => {
    switch (currentView.entityType) {
      case "user":
        return (
          <UserModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "role":
        return (
          <RoleModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "permission":
        return (
          <PermissionModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenant":
        return (
          <TenantModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantProfile":
        return (
          <TenantProfileModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "vatStatus":
        return (
          <VatStatusModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "grossReceiptsStatus":
        return (
          <GrossReceiptsStatusModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantType":
        return (
          <TenantTypeModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantStatus":
        return (
          <TenantStatusModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "currency":
        return (
          <CurrencyModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantPlan":
        return (
          <TenantPlanModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "country":
        return (
          <CountryModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "provinceState":
        return (
          <ProvinceStateModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "creditTier":
        return (
          <CreditTierModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "creditAccount":
        return (
          <CreditAccountModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "creditPurchase":
        return (
          <CreditPurchaseModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "creditMovement":
        return (
          <CreditMovementModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "workerEvent":
        return (
          <WorkerEventModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "simulationSession":
        return (
          <SimulationSessionModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "snapshotOverride":
        return (
          <SnapshotOverrideModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "botRun":
        return (
          <BotRunModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "botPhase":
        return (
          <BotPhaseModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "botStep":
        return (
          <BotStepModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "botError":
        return (
          <BotErrorModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "satelliteMachine":
        return (
          <SatelliteMachineModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "satelliteTask":
        return (
          <SatelliteTaskModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "satelliteHeartbeat":
        return (
          <SatelliteHeartbeatModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "dashboardWidget":
        return (
          <DashboardWidgetModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantWidgetAccess":
        return (
          <TenantWidgetAccessModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "userWidgetConfig":
        return (
          <UserWidgetConfigModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "dashboardLayoutTemplate":
        return (
          <DashboardLayoutTemplateModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "report":
        return (
          <ReportModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "reportType":
        return (
          <ReportTypeModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "userNotification":
        return (
          <UserNotificationModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "userNotificationPreference":
        return (
          <UserNotificationPreferenceModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "alertRule":
        return (
          <AlertRuleModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "alertSubscription":
        return (
          <AlertSubscriptionModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "emailVerification":
        return (
          <EmailVerificationModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "showcaseWorkflowState":
        return (
          <ShowcaseWorkflowStateModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "showcaseCategory":
        return (
          <ShowcaseCategoryModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "showcaseLine":
        return (
          <ShowcaseLineModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "designShowcase":
        return (
          <DesignShowcaseModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "theme":
        return (
          <ThemeModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "authorComposer":
        return (
          <AuthorComposerModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "collectiveManagementSociety":
        return (
          <CollectiveManagementSocietyModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "authorCollectingSociety":
        return (
          <AuthorCollectingSocietyModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "publisher":
        return (
          <PublisherModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "authorPublisher":
        return (
          <AuthorPublisherModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "workAuthorPublisher":
        return (
          <WorkAuthorPublisherModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "publisherCollectingSociety":
        return (
          <PublisherCollectingSocietyModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "publisherRepresentative":
        return (
          <PublisherRepresentativeModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "editionType":
        return (
          <EditionTypeModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "musicalWork":
        return (
          <MusicalWorkModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "phonogram":
        return (
          <PhonogramModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "territory":
        return (
          <TerritoryModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "musicalWorkLink":
        return (
          <MusicalWorkLinkModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "platform":
        return (
          <PlatformModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "platformLinkType":
        return (
          <PlatformLinkTypeModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "workAuthor":
        return (
          <WorkAuthorModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "edition":
        return (
          <EditionModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "signedEdition":
        return (
          <SignedEditionModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "editionContractPublisher":
        return (
          <EditionContractPublisherModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "editionDocumentation":
        return (
          <EditionDocumentationModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "signedContract":
        return (
          <SignedContractModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "editionDocumentType":
        return (
          <EditionDocumentTypeModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "associatedDocumentEdition":
        return (
          <AssociatedDocumentEditionModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "associatedDocumentSignedEdition":
        return (
          <AssociatedDocumentSignedEditionModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "signedEditionBlockchainCert":
        return (
          <SignedEditionBlockchainCertModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "userAttachmentEdition":
        return (
          <UserAttachmentEditionModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "interpreter":
        return (
          <InterpreterModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "musicalGenre":
        return (
          <MusicalGenreModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "contractObservation":
        return (
          <ContractObservationModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "paymentReceiptType":
        return (
          <PaymentReceiptTypeModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "paymentReceiptUse":
        return (
          <PaymentReceiptUseModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "paymentReceipt":
        return (
          <PaymentReceiptModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tadManagerConfig":
        return (
          <TadManagerConfigModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "documentGenerationParams":
        return (
          <DocumentGenerationParamsModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "editionDocumentationWorkflowState":
        return (
          <EditionDocumentationWorkflowStateModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "signedEditionDndaWorkflowState":
        return (
          <SignedEditionDndaWorkflowStateModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "signedEditionSadaicWorkflowState":
        return (
          <SignedEditionSadaicWorkflowStateModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "llmProvider":
        return (
          <LlmProviderModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantLlmConfig":
        return (
          <TenantLlmConfigModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantDocument":
        return (
          <TenantDocumentModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "aiSearchConversation":
        return (
          <AiSearchConversationModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "aiSearchResponse":
        return (
          <AiSearchResponseModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "aiSearchToolCall":
        return (
          <AiSearchToolCallModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantTokenUsage":
        return (
          <TenantTokenUsageModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "tenantStorageUsage":
        return (
          <TenantStorageUsageModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "aiSearchAutoEval":
        return (
          <AiSearchAutoEvalModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "aiSearchPattern":
        return (
          <AiSearchPatternModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "evaluationQuery":
        return (
          <EvaluationQueryModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "queryPattern":
        return (
          <QueryPatternModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "esignatureConfig":
        return (
          <EsignatureConfigModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "esignatureDocument":
        return (
          <EsignatureDocumentModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "esignatureRecipient":
        return (
          <EsignatureRecipientModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      case "esignatureWebhookEvent":
        return (
          <EsignatureWebhookEventModalContent
            entityId={currentView.entityId}
            mode={currentView.mode}
            onClose={handleClose}
          />
        );
      default:
        return (
          <Typography>
            Entidad no encontrada: {currentView.entityType}
          </Typography>
        );
    }
  };

  return (
    <Dialog
      open={modalViewOpen}
      onClose={handleClose}
      maxWidth={isWideModal ? false : modalBp}
      fullWidth={!isWideModal}
      sx={{
        zIndex: 10100,
        "& .MuiDialog-paper": {
          height: "90vh",
          maxHeight: "90vh",
          ...(isWideModal
            ? { width: "min(1400px, 90vw)", maxWidth: "90vw" }
            : {}),
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 1,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {canGoBack && (
            <IconButton onClick={handleBack} size="small">
              <ArrowBackIcon />
            </IconButton>
          )}
          <Typography variant="subtitle2" color="text.secondary">
            {modalViewStack.length > 1 ? `(${modalViewStack.length})` : ""}
          </Typography>
        </Box>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0, overflow: "auto" }}>
        {renderContent()}
      </DialogContent>
    </Dialog>
  );
});
